import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  colorLandingBrand,
  colorLandingDarkBar,
  colorLandingDarkMuted,
  colorLandingDarkPanel,
  colorLandingDarkText,
  colorLandingInk,
  colorLandingSurface,
  fontLandingSans,
  radiusLandingControl,
} from "src/design/tokens";

// Occupied-tables profile of a service: the dimmed bars are the empty window
// (15:00 → 18:00) the copy points at.
const SLOTS = [
  { hour: "12h", height: 52, dim: false },
  { hour: "13h", height: 76, dim: false },
  { hour: "14h", height: 58, dim: false },
  { hour: "15h", height: 22, dim: true },
  { hour: "16h", height: 16, dim: true },
  { hour: "17h", height: 26, dim: true },
  { hour: "18h", height: 56, dim: false },
  { hour: "19h", height: 70, dim: false },
  { hour: "20h", height: 92, dim: false },
  { hour: "21h", height: 88, dim: false },
  { hour: "22h", height: 44, dim: false },
  { hour: "23h", height: 32, dim: false },
];

/** Dark "off-peak slots" panel: bar profile plus the offer nudge. */
export const QuietSlotsPanel = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: colorLandingInk,
        borderRadius: radiusLandingControl,
        px: 1.75,
        py: 1.625,
        color: colorLandingDarkText,
      }}
    >
      <Typography
        component="h5"
        sx={{ fontSize: 12.5, fontWeight: 700, color: colorLandingSurface }}
      >
        {t("landingPage.ecosystem.dashboard.quietSlots")}
      </Typography>
      <Typography sx={{ fontSize: 10, color: colorLandingDarkMuted, mt: 0.25, mb: 1.25 }}>
        {t("landingPage.ecosystem.dashboard.quietSlotsSub")}
      </Typography>

      <Box sx={{ display: "flex", gap: 0.5, alignItems: "flex-end", height: 52 }}>
        {SLOTS.map((slot) => (
          <Box
            key={slot.hour}
            sx={{
              flex: 1,
              minHeight: 6,
              height: `${slot.height}%`,
              borderRadius: "3px",
              backgroundColor: slot.dim ? colorLandingDarkBar : colorLandingBrand,
            }}
          />
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: 0.5, mt: 0.625 }}>
        {SLOTS.map((slot) => (
          <Typography
            key={slot.hour}
            sx={{
              flex: 1,
              textAlign: "center",
              fontSize: 7.5,
              color: colorLandingDarkMuted,
            }}
          >
            {slot.hour}
          </Typography>
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.25,
          mt: 1.375,
          px: 1.25,
          py: 1.125,
          backgroundColor: colorLandingDarkPanel,
          borderRadius: "9px",
        }}
      >
        <Typography sx={{ fontSize: 10, color: colorLandingDarkText, flex: 1 }}>
          <Box component="span" sx={{ fontWeight: 700, color: colorLandingSurface }}>
            {t("landingPage.ecosystem.dashboard.quietMessage")}
          </Box>
          {t("landingPage.ecosystem.dashboard.quietMessageEnd")}
        </Typography>
        <Box
          component="span"
          sx={{
            backgroundColor: colorLandingBrand,
            color: colorLandingSurface,
            borderRadius: "8px",
            px: 1.375,
            py: 0.875,
            fontSize: 10,
            fontWeight: 700,
            fontFamily: fontLandingSans,
            whiteSpace: "nowrap",
          }}
        >
          {t("landingPage.ecosystem.dashboard.quietCta")}
        </Box>
      </Box>
    </Box>
  );
};
